/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EmptyMinicart from "./components/EmptyMinicart.vue";
import IconClose from "../../../icons/icon-close.svg";
import IconPlus from "../../../icons/icon-plus.svg";
import IconMinus from "../../../icons/icon-minus.svg";

import {
	createNamespacedHelpers
} from 'vuex';

const { mapState, mapActions, mapGetters } = createNamespacedHelpers("cart");

let resizeChange = null;

import {
	GETTER_CART,
	ACTION_INIT_CART,
	ACTION_REMOVE_ITEM,
	ACTION_CHANGE_QUANTITY,
	GETTER_SETTINGS,
	ACTION_SAVE_FOR_LATER
} from './store/cart/cart';

import {
	CHECKOUT
} from "../core/objects";

const __vue_script__ = {
	name: 'Minicart',
	data: () => ({
		isOpened: false,
		height: window.innerHeight,
		customizer: {},
		checkoutUrl: CHECKOUT
	}),
	mounted() {
		document.addEventListener('minicart:open', this.openCart);

		window.addEventListener('resize', () => {
			clearTimeout(resizeChange);

			resizeChange = setTimeout(() => {
				this.height = window.innerHeight;
			}, 50);
		});

		this.initCustomizer();
	},
	computed: {
		...mapGetters([
			GETTER_CART,
			GETTER_SETTINGS,
		]),
		getHeight() {
			return `${this.height}px`;
		},
		isEmptyMinicart() {
			return this.cart.item_count === 0;
		}
	},
	methods: {
		...mapActions([
			ACTION_INIT_CART,
			ACTION_REMOVE_ITEM,
			ACTION_CHANGE_QUANTITY,
			ACTION_SAVE_FOR_LATER,
		]),
		initCustomizer() {
			const customizerDataHolder = document.getElementById('minicart-customizer-data');

			if(!customizerDataHolder) {
				return null;
			}

			try {
				const data = JSON.parse(customizerDataHolder.innerHTML);

				this.customizer = Object.assign({}, {}, data.customizer);
			} catch (e) {}
		},
		closeCart(e) {
			if (e) {
				e.preventDefault();
			}

			this.clearBodyScroll();

			this.isOpened = false;
		},
		openCart() {
			this.bodyScroll();

			this.isOpened = true;
		},
		clearBodyScroll() {
			bodyScrollLock.clearAllBodyScrollLocks();
			this.$el.querySelector('.js-minicart-items').scrollTo(0, 0);
		},
		bodyScroll() {
			bodyScrollLock.disableBodyScroll(this.$el.querySelector('.js-minicart-items'));
		}
	},
	components: {
		IconClose,
		IconMinus,
		IconPlus,
		EmptyMinicart
	}
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "minicart", attrs: { id: "minicart" } }, [
    _c("div", {
      class: {
        minicart__overlay: true,
        "minicart__overlay--shown": _vm.isOpened,
      },
      on: { click: _vm.closeCart },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "minicart__container",
        class: { "minicart__container--open": _vm.isOpened },
        style: {
          height: _vm.getHeight,
        },
      },
      [
        _c("div", { staticClass: "minicart__wrapper" }, [
          _c(
            "div",
            { staticClass: "minicart__section minicart__section--header" },
            [
              _c("div", { staticClass: "minicart__header-wrapper" }, [
                _c("div", { staticClass: "minicart__title-wrapper" }, [
                  _c("h4", { staticClass: "minicart__title" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t\t" +
                        _vm._s(_vm._f("t")("cart.general.title")) +
                        "\n\t\t\t\t\t\t"
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "minicart__close",
                      on: { click: _vm.closeCart },
                    },
                    [_c("IconClose")],
                    1
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "minicart__body",
              class: { "minicart__body--empty": _vm.isEmptyMinicart },
            },
            [
              _vm.isEmptyMinicart
                ? _c("EmptyMinicart", {
                    attrs: {
                      "empty-button-text": _vm.customizer.empty_button_text,
                      "empty-button-url": _vm.customizer.empty_button_url,
                    },
                  })
                : _c(
                    "div",
                    {
                      staticClass:
                        "minicart__section minicart__section--items js-minicart-items",
                    },
                    _vm._l(_vm.cart.items, function (item) {
                      return _c(
                        "div",
                        { key: item.key, staticClass: "minicart-product" },
                        [
                          _c(
                            "div",
                            { staticClass: "minicart-product__wrapper" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "minicart-product__column minicart-product__column--left",
                                  attrs: { href: item.url },
                                },
                                [
                                  item.image
                                    ? _c("img", {
                                        staticClass: "minicart-product__image",
                                        attrs: {
                                          src: _vm._f("img_url")(
                                            item.image.src,
                                            "79x"
                                          ),
                                          alt: item.image.alt,
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "minicart-product__column minicart-product__column--middle",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "minicart-product__title",
                                      attrs: { href: item.url },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(item.title) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(
                                    item.filteredProperties,
                                    function (property, key) {
                                      return _c(
                                        "p",
                                        {
                                          key: key,
                                          staticClass:
                                            "minicart-product__property",
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(key) +
                                              ": " +
                                              _vm._s(property) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "minicart-product__remove-button",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeItem({
                                            key: item.key,
                                          })
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("t")("cart.general.remove")
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "minicart-product__column minicart-product__column--right",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "minicart-product__quantity",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "minicart-product__quantity-button",
                                          on: {
                                            click: function ($event) {
                                              return _vm.changeQuantity({
                                                key: item.key,
                                                quantity: item.quantity - 1,
                                              })
                                            },
                                          },
                                        },
                                        [_c("IconMinus")],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "minicart-product__quantity-input-wrapper",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number.lazy",
                                                value: item.quantity,
                                                expression: "item.quantity",
                                                modifiers: {
                                                  number: true,
                                                  lazy: true,
                                                },
                                              },
                                            ],
                                            staticClass:
                                              "minicart-product__quantity-input",
                                            attrs: { type: "number" },
                                            domProps: { value: item.quantity },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  _vm.$set(
                                                    item,
                                                    "quantity",
                                                    _vm._n($event.target.value)
                                                  )
                                                },
                                                function ($event) {
                                                  return _vm.changeQuantity({
                                                    key: item.key,
                                                    quantity: item.quantity,
                                                  })
                                                },
                                              ],
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "minicart-product__quantity-button",
                                          on: {
                                            click: function ($event) {
                                              return _vm.changeQuantity({
                                                key: item.key,
                                                quantity: item.quantity + 1,
                                              })
                                            },
                                          },
                                        },
                                        [_c("IconPlus")],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "button",
                                      {
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.saveForLater({
                                              key: item.key,
                                            })
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\tSave For Later\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass: "minicart-product__subtotal",
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm._f("money")(item.final_price)
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.cart.item_count
            ? _c(
                "div",
                { staticClass: "minicart__section minicart__section--footer" },
                [
                  _c("div", { staticClass: "minicart__subtotal-wrapper" }, [
                    _c("div", { staticClass: "minicart__subtotal-label" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm._f("t")("cart.general.subtotal")) +
                          "\n\t\t\t\t\t"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "minicart__subtotal-value" }, [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(_vm._f("money")(_vm.cart.total_price)) +
                          "\n\t\t\t\t\t"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "minicart__footer-button button button--primary button--reverse-hover",
                      attrs: { href: _vm._f("routes")(_vm.checkoutUrl) },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm._f("t")("cart.general.checkout")) +
                          "\n\t\t\t\t"
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "assets-extend/js/vue/Minicart.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__